/**
 * NewVersionBanner — Floating top banner that appears when a new
 * deployment is detected. Offers a one-click "Recargar" that force-reloads
 * the app bypassing cache, plus a dismiss button.
 *
 * Renders nothing (returns null) when no new version is available.
 */
import { RefreshCw, Sparkles, X } from 'lucide-react';
import { useNewVersionBanner } from '../hooks/useNewVersionBanner';

const NewVersionBanner = () => {
  const { hasNewVersion, reload, dismiss } = useNewVersionBanner();

  if (!hasNewVersion) return null;

  return (
    <div className="new-version-banner" role="status" aria-live="polite" data-testid="new-version-banner">
      <Sparkles size={14} className="nvb-icon" />
      <span className="nvb-text">
        <b>Nueva versión disponible</b> — recargá para verla.
        <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>R</kbd>
      </span>
      <button className="nvb-reload" onClick={reload} data-testid="new-version-reload">
        <RefreshCw size={12} /> Recargar
      </button>
      <button className="nvb-dismiss" onClick={dismiss} aria-label="Cerrar" data-testid="new-version-dismiss">
        <X size={14} />
      </button>
    </div>
  );
};

export default NewVersionBanner;
